import { render, staticRenderFns } from "./CommonTag.vue?vue&type=template&id=21fab812&scoped=true&"
import script from "./CommonTag.vue?vue&type=script&lang=js&"
export * from "./CommonTag.vue?vue&type=script&lang=js&"
import style0 from "./CommonTag.vue?vue&type=style&index=0&id=21fab812&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fab812",
  null
  
)

export default component.exports